import styled from 'styled-components';
import { Table } from 'semantic-ui-react';

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  background: #FFFFFF;
`;

export const Content = styled.div`
  /* max-width: 1100px; */

  /* margin: 10px auto; */
  h1{
    text-align: center;
    font-size: 18px;
    margin-top: 1rem;
    strong {
      color: #05314f;
    }
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .5rem;
  }
`;
export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  
  & i{
    height: 75% !important;
  }
`;


export const Input = styled.input`
  height:35px;
  width: 100%;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;
export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }

  tfoot{
    a{
      color: #000000 !important;

      i{
        color: #000000 !important;
      }
    }
  }
`;